var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinancials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.25 5.756C11.5714 5.51676 10.8453 5.44375 10.1326 5.54309C9.41991 5.64243 8.74144 5.91124 8.15411 6.32694C7.56677 6.74265 7.08769 7.29315 6.75705 7.93225C6.42641 8.57136 6.25385 9.28043 6.25385 10C6.25385 10.7196 6.42641 11.4286 6.75705 12.0677C7.08769 12.7069 7.56677 13.2573 8.15411 13.6731C8.74144 14.0888 9.41991 14.3576 10.1326 14.4569C10.8453 14.5563 11.5714 14.4832 12.25 14.244M5.5 8.5H10.75M5.5 11.5H10.75M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancials);
export default __webpack_public_path__ + "static/media/financials.4c20510be948dc4d986bf8135659d018.svg";
export { ForwardRef as ReactComponent };